import React from "react";

const FacebookIcon = ({ ...props }) => (
  <svg
    width="40"
    height="41"
    viewBox="0 0 40 41"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        d="M40 20.125C40 9.07933 31.0457 0.125031 20 0.125031C8.9543 0.125031 0 9.07933 0 20.125C0 30.1075 7.31367 38.3817 16.875 39.8821V25.9063H11.7969V20.125H16.875V15.7188C16.875 10.7063 19.8609 7.93753 24.4293 7.93753C26.6168 7.93753 28.9062 8.32816 28.9062 8.32816V13.25H26.3844C23.9 13.25 23.125 14.7918 23.125 16.375V20.125H28.6719L27.7852 25.9063H23.125V39.8821C32.6863 38.3817 40 30.1075 40 20.125Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0 0.125031)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default FacebookIcon;
